import { lockScroll, unlockScroll } from '../utils/util-functions';

export default (node) => {
  const searchInput = node.querySelector('[data-search-input]');
  const clearButton = node.querySelector('[data-clear-button]');
  const closeButton = node.querySelector('[data-close-search]');
  const trendingSection = node.querySelector('#trending-products');
  const resultsSection = node.querySelector('[data-search-results]');
  const productsTab = node.querySelector('[data-tab="product"]');
  const pagesTab = node.querySelector('[data-tab="page"]');
  const resultsContainer = node.querySelector('[data-results-container]');
  const overlayContainer = node.querySelector('.bg-surface-secondary');
  const noResultsText = node.getAttribute('data-no-results-text');
  const overlay = node.querySelector('[data-search-overlay]');
  const searchForm = node.querySelector('[data-form-search]');

  // Set aria-live for accessibility
  resultsContainer.setAttribute('aria-live', 'polite');

  let searchType = 'product';

  const toggleSearchVisibility = () => {
    node.classList.toggle('hidden');

    // Add or remove outside click listener based on the visibility
    if (!node.classList.contains('hidden')) {
      document.addEventListener('mousedown', handleOutsideClick);
      searchInput.focus();
      lockScroll();
      document.dispatchEvent(new CustomEvent('desktop-menu:close'));
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
      unlockScroll();
    }
  };

  const handleOutsideClick = (event) => {
    // Check if the click is outside the overlay container
    if (!overlayContainer.contains(event.target)) {
      toggleSearchVisibility();
    }
  };

  // Event handlers
  const handleSearchInput = () => {
    if (searchInput.value) {
      clearButton.classList.remove('hidden');
      trendingSection.classList.add('hidden');
      resultsSection.classList.remove('hidden');
      searchContent(searchInput.value);
    } else {
      clearButton.classList.add('hidden');
      trendingSection.classList.remove('hidden');
      resultsSection.classList.add('hidden');
    }
  };

  const clearSearch = () => {
    searchInput.value = '';
    handleSearchInput();
  };

  const setSearchType = (type) => {
    searchType = type;

    // Reset both tabs: remove underline and primary text color, add secondary text color
    productsTab.classList.remove(
      'border-b-2',
      'border-current',
      'text-text-primary'
    );
    productsTab.classList.add('text-text-tertiary');
    pagesTab.classList.remove(
      'border-b-2',
      'border-current',
      'text-text-primary'
    );
    pagesTab.classList.add('text-text-tertiary');

    // Apply active styles to the selected tab
    if (type === 'product') {
      productsTab.classList.add(
        'border-b-2',
        'border-current',
        'text-text-primary'
      );
      productsTab.classList.remove('text-text-tertiary');
      resultsContainer.classList.remove('pages-results');
    } else {
      pagesTab.classList.add(
        'border-b-2',
        'border-current',
        'text-text-primary'
      );
      pagesTab.classList.remove('text-text-tertiary');
      resultsContainer.classList.add('pages-results');
    }

    if (searchInput.value) {
      searchContent(searchInput.value);
    }
  };

  const searchContent = (query) => {
    resultsContainer.innerHTML = '';
    const resourceType = searchType === 'product' ? 'product' : 'page';

    fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=${resourceType}`
    )
      .then((response) => response.json())
      .then((data) => {
        let results =
          resourceType === 'product'
            ? data.resources.results.products
            : data.resources.results.pages;

            const excludeHandles = node.getAttribute('data-search-exclude-products').split(',');

            results = results.filter(product => !excludeHandles.includes(product.handle));
        if (results.length > 0) {
          resultsContainer.innerHTML = '';
          results.forEach((item, index) => {
            const itemHTML = `
                <a class="product-item" href="${item.url}">
                  ${item.featured_image ? `<img src="${item.featured_image.url}" alt="${item.title}" class="product-image">` : '<div class="md:hidden">&nbsp;</div>'}
                  <div class="product-text">
                    <p class="md:text-title-sm">${item.title}</p>
                    <p class="md:text-body-xs text-body-2xs text-text-tertiary">${resourceType === 'product' ? item.vendor : 'Page'}</p>
                  </div>
                </a>`;
            resultsContainer.insertAdjacentHTML('beforeend', itemHTML);
          });
        } else {
          resultsContainer.innerHTML = `<p class="text-center mt-4 md:col-span-5">${noResultsText}</p>`;
        }
      });
  };

  // Event listeners
  searchInput.addEventListener('input', handleSearchInput);
  clearButton.addEventListener('click', clearSearch);
  closeButton.addEventListener('click', toggleSearchVisibility);
  productsTab.addEventListener('click', () => setSearchType('product'));
  pagesTab.addEventListener('click', () => setSearchType('page'));
  overlay.addEventListener('click', toggleSearchVisibility);
  document.addEventListener('search:open', toggleSearchVisibility);

  searchForm.addEventListener('submit', (e) => {
    e.preventDefault();
    window.location.href = `/search?q=${searchInput.value}`;
  });

  // Initial state
  handleSearchInput();
};
